export const CircularDownSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6843 21.2386C15.6613 21.2705 15.631 21.2966 15.596 21.3145C15.5609 21.3324 15.5221 21.3418 15.4827 21.3418C15.4434 21.3418 15.4046 21.3324 15.3695 21.3145C15.3345 21.2966 15.3042 21.2705 15.2812 21.2386L9.71866 13.5511C9.59991 13.3855 9.71866 13.1543 9.92178 13.1543H11.3874C11.7062 13.1543 12.0093 13.3074 12.1968 13.5668L15.4812 18.1105L18.7687 13.5668C18.9562 13.3074 19.2562 13.1543 19.5781 13.1543H21.0437C21.2468 13.1543 21.3656 13.3855 21.2468 13.5511L15.6843 21.2386Z"
        fill="black"
      />
      <path
        d="M15.479 30.5C7.74775 30.5 1.479 24.2312 1.479 16.5C1.479 8.76875 7.74775 2.5 15.479 2.5C23.2103 2.5 29.479 8.76875 29.479 16.5C29.479 24.2312 23.2103 30.5 15.479 30.5ZM15.479 4.875C9.06025 4.875 3.854 10.0812 3.854 16.5C3.854 22.9187 9.06025 28.125 15.479 28.125C21.8978 28.125 27.104 22.9187 27.104 16.5C27.104 10.0812 21.8978 4.875 15.479 4.875Z"
        fill="black"
      />
    </svg>
  )
}
